export const VIEW_INDEX = {
  1: ["C1"],
  2: ["C2"],
  3: ["C2"],
  4: ["C2"],
  5: ["C3"],
  6: ["C4"],
  7: ["C4"],
  8: ["C1"],
  9: ["C2"],
  10: ["C2"],
  11: ["C2"],
  12: ["C3"],
  13: ["C4"],
  14: ["C4"],
  15: ["C1"],
  16: ["C2"],
  17: ["C2"],
  18: ["C2"],
  19: ["C3"],
  20: ["C4"],
  21: ["C4"],
  22: ["C1"],
  23: ["C2"],
  24: ["C2"],
  25: ["C2"],
  26: ["C3"],
  27: ["C4"],
  28: ["C4"],
  29: ["C1"],
  30: ["C2"],
  31: ["C2"],
  32: ["C2"],
  33: ["C3"],
  34: ["C4"],
  35: ["C4"],
  36: ["C1"],
  37: ["C2"],
  38: ["C2"],
  39: ["C2"],
  40: ["C3"],
  41: ["C4"],
  42: ["C4"],
  43: ["C1"],
  44: ["C2"],
  45: ["C2"],
  46: ["C2"],
  47: ["C3"],
  48: ["C4"],
  49: ["C4"],
  50: ["C1"],
  51: ["C2"],
  52: ["C2"],
  53: ["C2"],
  54: ["C3"],
  55: ["C4"],
  56: ["C4"],
  57: ["C1"],
  58: ["C2"],
  59: ["C2"],
  60: ["C2"],
  61: ["C3"],
  62: ["C4"],
  63: ["C4"],
  64: ["C1"],
  65: ["C2"],
  66: ["C2"],
  67: ["C2"],
  68: ["C3"],
  69: ["C4"],
  70: ["C4"],
  71: ["C1"],
  72: ["C2"],
  73: ["C2"],
  74: ["C2"],
  75: ["C3"],
  76: ["C4"],
  77: ["C4"],
  78: ["C1"],
  79: ["C2"],
  80: ["C2"],
  81: ["C2"],
  82: ["C3"],
  83: ["C4"],
  84: ["C4"],
  85: ["C1"],
  86: ["C2"],
  87: ["C2"],
  88: ["C2"],
  89: ["C3"],
  90: ["C4"],
  91: ["C4"],
  92: ["C1"],
  93: ["C2"],
  94: ["C2"],
  95: ["C2"],
  96: ["C3"],
  97: ["C4"],
  98: ["C4"],
  99: ["C1"],
  100: ["C2"],
  101: ["C2"],
  102: ["C2"],
  103: ["C3"],
  104: ["C4"],
  105: ["C1"],
  106: ["C2"],
  107: ["C2"],
  108: ["C2"],
  109: ["C3"],
  110: ["C4"],
  111: ["C1"],
  112: ["C2"],
  113: ["C2"],
  114: ["C2"],
  115: ["C3"],
  116: ["C4"],
  117: ["C1"],
  118: ["C2"],
  119: ["C2"],
  120: ["C2"],
  121: ["C3"],
  122: ["C4"],
  123: ["C1"],
  124: ["C2"],
  125: ["C2"],
  126: ["C2"],
  127: ["C3"],
  128: ["C4"],
  129: ["C1"],
  130: ["C2"],
  131: ["C2"],
  132: ["C2"],
  133: ["C3"],
  134: ["C4"],
  135: ["C1"],
  136: ["C2"],
  137: ["C2"],
  138: ["C2"],
  139: ["C3"],
  140: ["C4"],
  141: ["C1"],
  142: ["C2"],
  143: ["C2"],
  144: ["C2"],
  145: ["C3"],
  146: ["C4"],
  147: ["C1", "C2"],
  148: ["C3"],
  149: ["C4"],
}
